import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from './components/layout/Layout';
import HeroSection from './components/sections/HeroSection';
import ServicesSection from './components/sections/ServicesSection';
import AISolutionsSection from './components/sections/AISolutionsSection';
import ProductShowcaseSection from './components/sections/ProductShowcaseSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import TrainingSection from './components/sections/TrainingSection';

const MarigoldWebsite: React.FC = () => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const canonical = origin ? `${origin}/` : '/';
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Marigold One11',
    url: origin || 'https://localhost:3111',
    logo: `${origin || ''}/assets/images/marigold-logo.png`,
    sameAs: [
      'https://www.linkedin.com/company/marigold-one11',
      'https://twitter.com/marigoldone11'
    ]
  };
  return (
    <Layout>
      <Helmet>
        <title>Marigold One11 — AI Solutions, Automation, and Training</title>
        <meta name="description" content="AI-driven business solutions that save time at every step. Services include AI integration, automation, analytics, and training." />
        <link rel="canonical" href={canonical} />
        <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      </Helmet>
      <HeroSection />
      <div className="cv-auto">
        <ServicesSection />
        <AISolutionsSection />
        <ProductShowcaseSection />
        <TestimonialsSection />
        <TrainingSection />
      </div>
    </Layout>
  );
};

export default MarigoldWebsite;